<template>
  <div>
    <v-container fluid>
      <v-layout>
        <v-flex xs2 class="align-self-center text-xs-center mr-3">
          <v-icon :color="iconColor">{{icon}}</v-icon>
        </v-flex>
        <v-flex xs10>
          {{message}}
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider/>
  </div>
</template>

<script>
  export default {
    name: 'announcement-panel-row',
    props: {
      icon: {
        required: true,
        validator: value => {
          return [
            'info',
            'warning',
            'error',
            'priority_high'
          ].indexOf(value) !== -1
        }
      },
      message: {
        required: true
      },
      iconColor: {
        required: true
      }
    },
    mixins: [],
    data () {
      return {}
    },
    methods: {},
    computed: {},
    watch: {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/announcement/AnnouncementPanelRow.vue